import { getFormattedDate } from "../../utils/getDate";

export const Additional = () => {
  return (
    <div className="additional">
      <p className="additional__title">Дополнительная информация</p>
      <div className="additional__wrapper additional__wrapper--mobile">
        <div className="additional__thumb">
          <div className="additional__item">
            <p className="additional__text">Обновлено</p>
            <p className="additional__description">
              {getFormattedDate("today")}
            </p>
          </div>

          <div className="additional__item">
            <p className="additional__text">Установлено</p>
            <p className="additional__description">20794</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Возраст</p>
            <p className="additional__description">21+</p>
          </div>
        </div>
        <div className="additional__thumb">
          <div className="additional__item">
            <p className="additional__text">Размер</p>
            <p className="additional__description">3.3MB</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Версия</p>
            <p className="additional__description">2.2</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Разработчик</p>
            <p className="additional__description">Balloon</p>
          </div>
        </div>
      </div>
      <div className="additional__wrapper additional__wrapper--desktop">
        <div className="additional__thumb">
          <div className="additional__item">
            <p className="additional__text">Обновлено</p>
            <p className="additional__description">
              {getFormattedDate("today")}
            </p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Размер</p>
            <p className="additional__description">3.3MB</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Установлено</p>
            <p className="additional__description">20794</p>
          </div>
        </div>
        <div className="additional__thumb">
          <div className="additional__item">
            <p className="additional__text">Версия</p>
            <p className="additional__description">2.2</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Возраст</p>
            <p className="additional__description">21+</p>
          </div>
          <div className="additional__item">
            <p className="additional__text">Разработчик</p>
            <p className="additional__description">Balloon</p>
          </div>
        </div>
      </div>
    </div>
  );
};
